import React, { Component } from "react";
import down from "../../../assets/icons/down.svg";
import "./DropdownSearch.scss";

export interface IProps {
  options: any;
  searchKey: string;
  placeholder?: string;
  noDataMsg?: string;
  isDownArrow?: boolean;
  id?: string;
  name?: string;
  disabled?: boolean;
  errorText?: string;
  autoComplete?: string;
  searchLength: number;
  className?: string;
  defaultValue?: string;
  required?: boolean;
  onChange?: (value: string) => void;
  onOptionSelect?: (value: any) => void;
  onBlur?: (value: any) => void;
  hideSuggestion?: boolean;
  autoSelectOff?: boolean;
  disableTick?: boolean;
  skipSearching?: boolean;
  ariaLabel?: string;
  ariaLabelledBy?: string;
}

export interface IState {
  isShowSuggestions: boolean;
  value: string;
  selectedObj?: object | undefined;
  activeIndex: number;
}
class DropdownSearch extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isShowSuggestions: false,
      value: props.defaultValue || "",
      activeIndex: -1,
      selectedObj:
        (this.props.defaultValue &&
          this.findFromList(this.props.options, this.props.defaultValue)) ||
        undefined,
    };
  }

  componentDidUpdate(prevProps: IProps) {
    //post getting the updated props, sets the selectedObj value to object with matching defaultvalue
    //if autoselectoff is true do not set the selectedObj value for ex refer city DD
    console.log(this.props.options);
    if (
      !prevProps.options.length &&
      this.props.options.length &&
      !this.state.selectedObj &&
      !this.props.autoSelectOff &&
      this.props.defaultValue &&
      this.state.selectedObj !== null
    ) {
      const matchedItem = this.findFromList(
        this.props.options,
        this.props.defaultValue
      );
      matchedItem &&
        this.setState({
          selectedObj: matchedItem,
        });
    }
  }

  findFromList = (list: Array<any>, lookFor: string) => {
    const matchedOption = list.filter((val: any) => {
      return (
        val[this.props.searchKey]?.toLowerCase() === lookFor?.toLowerCase() ||
        Number(lookFor) === Number(val[this.props.searchKey])
      );
    });
    if (matchedOption.length === 1) {
      return matchedOption[0];
    } else {
      return null;
    }
  };

  // static getDerivedStateFromProps(nextProps: IProps, prevState: IState) {
  //     if (nextProps.defaultValue !== prevState.value && nextProps.defaultValue !== undefined) {
  //         return { value: nextProps.defaultValue };
  //     } else return null;
  // }

  UNSAFE_componentWillReceiveProps(nextProps: IProps, prevState: IState) {
    if (
      nextProps.defaultValue !== prevState.value &&
      nextProps.defaultValue !== undefined
    ) {
      this.setState({ value: nextProps.defaultValue });
    }
  }

  onFocus = () => {
    if (
      this.props.searchLength === 0 ||
      this.state.value.length >= this.props.searchLength
    ) {
      this.setState({ isShowSuggestions: true });
    } else {
      this.setState({ isShowSuggestions: false });
    }
  };

  onChange = (value: any) => {
    if (value.trim().length >= this.props.searchLength) {
      this.setState({ isShowSuggestions: true });
    } else {
      this.setState({ isShowSuggestions: false });
    }
    this.setState({ value: value, selectedObj: undefined, activeIndex: -1 });
    this.props.onChange && this.props.onChange(value);
  };

  handleBlur = () => {
    setTimeout(() => {
      if (this.state.isShowSuggestions) {
        this.setState({ isShowSuggestions: false, activeIndex: -1 });
      }
      this.props.onBlur && this.props.onBlur(this.state.selectedObj);
    }, 300);
  };

  onOptionSelect = (item: any) => {
    this.setState({
      value: item[this.props.searchKey],
      selectedObj: item,
      isShowSuggestions: false,
      activeIndex: -1,
    });
    if (this.props.onOptionSelect) {
      this.props.onOptionSelect(item);
    }
  };
  //selects all the text on click
  handleClick = (event: any) => {
    if (!this.props.autoSelectOff) {
      !this.props.hideSuggestion && event.target.select();

      event.target.scrollIntoView({ behavior: "smooth", block: "center" });
      //after selecting the option if user clicks on dropdown user will be taken to the option selected in the list
      if (this.props.options.indexOf(this.state.selectedObj) >= 0) {
        var index = this.props.options.findIndex((val: any) =>
          val[this.props.searchKey]
            .toLowerCase()
            .includes(this.state.value.toLowerCase())
        );

        if (index > -1 && event.target.nextSibling)
          event.target.nextSibling.scrollTo(0, index * 60);
        //60px height of the list item
      }
    }
  };

  render() {
    const { isShowSuggestions, activeIndex } = this.state;
    let ddCount = 0;

    const noData = (
      <div className="dds_odiv">
        <div className="dds_oldiv">
          <span className="dds_olabel">{this.props.noDataMsg}</span>
        </div>
      </div>
    );
    let suggestions =
      this.state.isShowSuggestions &&
      !this.props.skipSearching &&
      this.state.value.length >= this.props.searchLength
        ? this.props.options.filter((item: any) => {
            if (
              item[this.props.searchKey]
                .toLowerCase()
                .includes(this.state.value.toLowerCase()) ||
              (this.props.options.indexOf(this.state.selectedObj) >= 0 &&
                !this.props.autoSelectOff)
            ) {
              ddCount++;
              return item;
            }
          })
        : this.props.skipSearching
        ? this.props.options.map((item: any) => {
            ddCount++;
            return item;
          })
        : null;
    // let suggestions =
    //   this.state.isShowSuggestions &&
    //   this.state.value.length >= this.props.searchLength
    //     ? this.props.options.filter((item: any, i: any) => {
    //         if (
    //           item[this.props.searchKey]
    //             .toLowerCase()
    //             .includes(this.state.value.toLowerCase()) ||
    //           (this.props.options.indexOf(this.state.selectedObj) >= 0 &&
    //             !this.props.autoSelectOff)
    //         ) {
    //           ddCount++;
    //           return item;
    //         }
    //       })
    //     : null;
    suggestions &&
      suggestions.sort((a: any, b: any) =>
        a[this.props.searchKey]
          .toLowerCase()
          .indexOf(this.state.value.toLowerCase()) <
        b[this.props.searchKey]
          .toLowerCase()
          .indexOf(this.state.value.toLowerCase())
          ? -1
          : b[this.props.searchKey]
              .toLowerCase()
              .indexOf(this.state.value.toLowerCase()) >
            a[this.props.searchKey]
              .toLowerCase()
              .indexOf(this.state.value.toLowerCase())
          ? 1
          : 0
      );
    const inputId = this.props.id || this.props.name;
    const listboxId = `${inputId || "ddsearch"}-listbox`;
    const errorId = inputId ? `${inputId}-error` : undefined;
    let showSuggestions =
      suggestions && suggestions.length > 0
        ? suggestions.map((item: any, i: any) => {
            let dropdownData = item[this.props.searchKey];
            const isSelected =
              this.state.selectedObj === item ||
              dropdownData === this.props.defaultValue;
            return (
              <div
                key={i}
                id={`${listboxId}-opt-${i}`}
                className={"dds_odiv" + (activeIndex === i ? " dds_active" : "")}
                role="option"
                aria-selected={!!isSelected}
                tabIndex={-1}
                onClick={() => this.onOptionSelect(item)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.onOptionSelect(item);
                  }
                }}
              >
                <div className="dds_oldiv">
                  <span
                    className={
                      this.props.disableTick ? "dd_lbl_notGrid" : "dd_lbl"
                    }
                  >
                    {!this.props.disableTick && isSelected ? (
                      <i className="edel-icon-tick" aria-hidden="true"></i>
                    ) : (
                      <i aria-hidden="true"></i>
                    )}
                    <span
                      className="dds_olabel"
                      dangerouslySetInnerHTML={{ __html: dropdownData }}
                    ></span>
                  </span>
                </div>
              </div>
            );
          })
        : null;

    return (
      <div className="dds_grp">
        <input
          name={this.props.name}
          id={inputId}
          type="text"
          role="combobox"
          aria-expanded={!!isShowSuggestions && !this.props.hideSuggestion}
          aria-controls={listboxId}
          aria-autocomplete="list"
          aria-activedescendant={
            isShowSuggestions && activeIndex >= 0
              ? `${listboxId}-opt-${activeIndex}`
              : undefined
          }
          aria-invalid={this.props.errorText ? true : undefined}
          aria-describedby={
            this.props.errorText && errorId ? errorId : undefined
          }
          aria-label={
            this.props.ariaLabelledBy
              ? undefined
              : this.props.ariaLabel ||
                (!inputId
                  ? this.props.placeholder || this.props.name || "Search and select"
                  : undefined)
          }
          aria-labelledby={this.props.ariaLabelledBy}
          required={this.props.required || undefined}
          aria-required={this.props.required ? true : undefined}
          className={
            "dds " +
            this.props.className +
            (this.props.errorText ? " error" : "")
          }
          onClick={this.handleClick}
          onChange={(e) => this.onChange(e.target.value)}
          onFocus={this.onFocus}
          onBlur={this.handleBlur}
          onKeyDown={(e) => {
            const count = Array.isArray(showSuggestions) ? showSuggestions.length : 0;
            if (e.key === "ArrowDown") {
              e.preventDefault();
              if (!isShowSuggestions) this.onFocus();
              this.setState((prev) => ({
                activeIndex: Math.min(prev.activeIndex + 1, count - 1),
              }));
            } else if (e.key === "ArrowUp") {
              e.preventDefault();
              this.setState((prev) => ({
                activeIndex: Math.max(prev.activeIndex - 1, 0),
              }));
            } else if (
              e.key === "Enter" &&
              isShowSuggestions &&
              activeIndex >= 0 &&
              Array.isArray(suggestions) &&
              suggestions[activeIndex]
            ) {
              e.preventDefault();
              this.onOptionSelect(suggestions[activeIndex]);
            } else if (e.key === "Escape") {
              this.setState({ isShowSuggestions: false, activeIndex: -1 });
            }
          }}
          value={this.state.value}
          readOnly={!this.props.hideSuggestion ? false : true}
          disabled={this.props.disabled}
          placeholder={this.props.placeholder}
          autoComplete={
            this.props.autoComplete ? this.props.autoComplete : "off"
          }
          style={
            this.props.isDownArrow ? { backgroundImage: `url(${down})` } : {}
          }
        />
        {!this.props.hideSuggestion &&
        isShowSuggestions &&
        (showSuggestions || this.props.noDataMsg) ? (
          <div className="option_grp" role="listbox" id={listboxId}>
            {ddCount ? showSuggestions : noData}
          </div>
        ) : null}
        {this.props.errorText && (
          <p className="help_text red" id={errorId} role="alert" aria-live="assertive">
            {this.props.errorText}
          </p>
        )}
      </div>
    );
  }
}

// export default React.memo(DropdownSearch);
export default DropdownSearch;
